import React, { useState, useEffect } from 'react';
import { Container, Col } from "react-bootstrap"
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { isAuthenticated as checkIsAuthenticated } from './admin/isAuthenticated';
import LogoSC from '../images/logos/logoSc.png'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Role, domain } from '../constants/constants';
import { FaHome, FaInfoCircle, FaBook, FaShieldAlt, FaQuestionCircle, FaSignOutAlt, FaTachometerAlt, FaUsers } from 'react-icons/fa';

export default function NavbarMenu() {
  const navigate = useNavigate();
  const [isAuthenticatedState, setIsAuthenticatedState] = useState(false);
  const [isAdminRole, setIsAdminRole] = useState(false);
  const [isOrgAdminRole, setIsOrgAdminRole] = useState(false);

  const handleLogout = () => {
    Cookies.remove('token', { domain: domain, path: '/' });
    setIsAuthenticatedState(false);
    navigate('/login');
  };


  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const result = await checkIsAuthenticated();

        const status = result.status

        if (status) {
          setIsAuthenticatedState(true);
          let role = result.role;
          if (role === Role.admin) {
            setIsAdminRole(true);
          }
          if (role === Role.organisationAdmin) {
            setIsOrgAdminRole(true);
          }
        } else {
          setIsAuthenticatedState(false);
        }
      } catch (error) {
        // console.error('Error checking authentication:', error);
      }
    };

    checkAuthentication();
  }, [navigate]);


  return (

    <Container>
      <div>
        <Navbar expand="lg">


          <Col xs={12} md={5}>
            <Navbar.Brand className="font-style" href="/">
              <img src={LogoSC} width={'450px'} alt="Logo" />
            </Navbar.Brand>
          </Col>


          <Col xs={12} md={8} className="navbar-links-col">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="justify-content-end" style={{ width: "100%" }}>
                <Nav.Link href="/"><FaHome    className="me-1" /> <b> Home</b></Nav.Link>
                <Nav.Link href="/about"><FaInfoCircle    className="me-1" /><b>About</b> </Nav.Link>
                <Nav.Link href="/tutorial"> <FaBook    className="me-1" /> <b>Tutorial</b></Nav.Link>
                <Nav.Link href="/privacy"><FaShieldAlt    className="me-1" /><b>Privacy</b> </Nav.Link>
                <Nav.Link href="/docs"><FaQuestionCircle    className="me-1" /><b>FAQ</b> </Nav.Link>
                <Nav>
                  {isAuthenticatedState ? (
                    <>
                      <Nav.Link href="/" onClick={handleLogout}>
                        <FaSignOutAlt  className="me-1" /> <b>Logout</b>
                      </Nav.Link>
                      {isAdminRole ? (
                        <>
                          <Nav.Link href="/dashboard"><FaTachometerAlt  className="me-1" /><b>Dashboard</b> </Nav.Link>
                        </>
                      ) : null}
                    </>
                  ) : 
                    <>
                      <Nav.Link href="/login"><FaUsers  className="me-1" /><b> Organisations</b> </Nav.Link>
                    </>}
                  {isOrgAdminRole ? (
                    <>
                      <Nav.Link href="/org-dashboard"><FaTachometerAlt  className="me-1" /><b> Dashboard</b> </Nav.Link>
                    </>
                  ) : null}
                </Nav>
              </Nav>
            </Navbar.Collapse>
            <hr className="custom-hr" />
          </Col>

        </Navbar>

      </div>
    </Container>

  );
}

